import React from 'react';
import { Heart, Instagram, Facebook } from 'lucide-react';
import { contactData, socialLinks } from '../../data/mock';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  // Navigation structure (same as header)
  const navStructure = [
    { key: 'home', href: '#home' },
    { key: 'about', href: '#about' },
    { key: 'services', href: '#services' },
    { key: 'portfolio', href: '#portfolio' },
    { key: 'contact', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#2C2C2C] text-[#FAF9F7]">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <span className="font-['Cormorant_Garamond'] text-3xl font-light tracking-wide">
                Alma Leve
              </span>
              <span className="block text-[0.65rem] tracking-[0.25em] uppercase text-[#C4B5A0] font-medium mt-[-2px]">
                Weddings
              </span>
            </div>
            <p className="text-[#D4C4B0] text-sm leading-relaxed max-w-md mb-8">
              {t('footer.description')}
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-4">
              <a
                href={socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-[#8B7D6B] flex items-center justify-center text-[#D4C4B0] hover:bg-[#C4B5A0] hover:border-[#C4B5A0] hover:text-[#2C2C2C] transition-all duration-300"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href={socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-[#8B7D6B] flex items-center justify-center text-[#D4C4B0] hover:bg-[#C4B5A0] hover:border-[#C4B5A0] hover:text-[#2C2C2C] transition-all duration-300"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="text-[0.7rem] tracking-[0.2em] uppercase text-[#C4B5A0] font-medium mb-6">
              {t('footer.navigation')}
            </h4>
            <ul className="space-y-3">
              {navStructure.map((link) => (
                <li key={link.key}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.href);
                    }}
                    className="text-[#D4C4B0] text-sm hover:text-[#FAF9F7] transition-colors duration-300"
                  >
                    {t(`nav.${link.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-[0.7rem] tracking-[0.2em] uppercase text-[#C4B5A0] font-medium mb-6">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm text-[#D4C4B0]">
              <li>
                <a href={`mailto:${contactData.email}`} className="hover:text-[#FAF9F7] transition-colors">
                  {contactData.email}
                </a>
              </li>
              <li>
                <a href={`tel:${contactData.phone}`} className="hover:text-[#FAF9F7] transition-colors">
                  {contactData.phone}
                </a>
              </li>
              <li>{contactData.location}</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#3D3D3D]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-[#8B7D6B]">
            <p>
              © {currentYear} Alma Leve Weddings. {t('footer.rights')}.
            </p>
            <p className="flex items-center gap-2">
              {t('footer.tagline')} <Heart size={14} className="text-[#C4B5A0]" fill="#C4B5A0" /> {t('footer.inPortugal')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
